let dt = new Date()
let dts = dt.getFullYear()+'-'+String(dt.getMonth()+1).padStart(2, '0')+'-'+String(dt.getDate()).padStart(2, '0')
dt = dt.getFullYear()+'-01-01'

const rootState = {
  assetClasses: [
    {name: 'Total', id: 0},
    {name: 'Kontant', id: 1},
    {name: 'Obligationer', id: 2},
    {name: 'Aktier', id: 3},
    {name: 'Hedgefonde', id: 4},
    {name: 'Finansiering', id: 5},
    {name: 'Ejendomme', id: 6},
    {name: 'Private Equity', id: 7},
    {name: 'Infrastruktur', id: 8},
    {name: 'Direkte investeringer', id: 9},
    {name: 'Honorar', id: 10},
    {name: 'Multi Strategi', id: 11},
    {name: 'Buffer', id: 12},
  ],
  personTypes: [
    {type: 'Client', name: 'Kunde'},
    {type: 'BankContact', name: 'Bank kontakt'},
    {type: 'Employee', name: 'Kollega'},
    {type: 'Administrator', name: 'Administrator'},
  ],
  personConsultantRelationType: [
    {type: 'primary', name: 'Primær'},
    {type: 'secondary', name: 'Sekundær'},
    {type: 'external', name: 'Ekstern'}
  ],
  contactTypes: [
    {type: 'Address', name: 'Adresse'},
    {type: 'PhoneNumber', name: 'Telefon'},
    {type: 'Email', name: 'Email'},
  ],
  coractTypes: [
    {key: 'div', id: 0, name: 'DIV', long_name: 'Udbytte'},
    {key: 'interest', id: 1, name: 'INT', long_name: 'Rente'},
    {key: 'stock', id: 2, name: 'STOCK', long_name: 'Udbtte i aktier'},
    {key: 'spin', id: 3, name: 'SPIN', long_name: 'Spin-off'},
    {key: 'stock_split', id: 4, name: 'SPLIT', long_name: 'Aktiesplit'}
  ],
  coractStatuses: [
    {key: 'suggested', id: 0, name: 'Foreslået', color: 'secondary'},
    {key: 'active', id: 1, name: 'Aktiv', color: 'success'},
    {key: 'rejected', id: 3, name: 'Afvist', color: 'danger'},
  ],
  communication_types: [
    {value: 'physical', label: 'fysisk'},
    {value: 'mail', label: 'mail'},
    {value: 'phone', label: 'telefon'},
    {value: 'log', label: 'log'},
  ],
  event_types: [
    {type: 'IncomeReceived', label: 'Modtaget indkomst', real: true},
    {type: 'CashEvent', label: 'Kontant begivenhed', real: true},
    {type: 'Trade', label: 'Handel', real: true},
    {type: 'TradeExpected', label: 'Forventet handel', real: false},
    {type: 'TradeCost', label: 'Handelsomkostning', real: true},
    {type: 'TradeCostExpected', label: 'Forventet handelsomkostning', real: false},
    {type: 'CashInterest', label: 'Rentetilskrivning', real: true},
    {type: 'DepositCost', label: 'Gebyr', real: true},
    {type: 'FeePayment', label: 'Honorarindbetaling', real: true},
    {type: 'FeeNeutralization', label: 'Honorar udligning', real: true},
    {type: 'FeeExpected', label: 'Honorarfaktura', real: false},
    {type: 'FeeCancel', label: 'Honorarfaktura udligning', real: false},
    {type: 'Income', label: 'Indkomst', real: false},
    {type: 'IncomeCancel', label: 'Indkomst udligning', real: false},
    {type: 'IncomeTrade', label: 'Indkomst handel', real: false},
    {type: 'Refund', label: 'Refusion', real: true},
    {type: 'RefundExpected', label: 'Forventet refusion', real: false},
    {type: 'RefundCancel', label: 'Refusion udligning', real: false},
    {type: 'TradeCancel', label: 'Handel udligning', real: false},
    {type: 'TradeCostCancel', label: 'Handelsomkostning udligning', real: false},
  ],
  roles: [
    {role: 'user', label: 'Bruger'},
    {role: 'admin', label: 'System administrator'},
    {role: 'employee', label: 'Ansat (SF)'},
    {role: 'client', label: 'Kunde'},
    {role: 'compliance', label: 'Compliance'},
    {role: 'role_manager', label: 'Rolle manager'},
    {role: 'reporting', label: 'Rapportering'},
    {role: 'aif', label: 'AIF'},
    {role: 'family', label: 'Familie'},
    {role: 'norway', label: 'Norge'},
  ],
  employeeDivision: [
    {name: 'Secure Spectrum'},
    {name: 'Alternative Equity Partners'},
  ],
  risks: [
    {key: 'low', label: 'Lav', variant: 'success', value: 0},
    {key: 'medium', label: 'Mellem', variant: 'warning', value: 1},
    {key: 'high', label: 'Høj', variant: 'danger', value: 2},
  ],
  covmat: [],
  covmat_index: [],
  start_date: dt,
  end_date: dts,
  primary_consultant: undefined,
  secondary_consultant: undefined,
  application_log_types: [
    {name: 'db_update', label: 'Opdatering'},
    {name: 'db_create', label: 'Oprettelse'},
    {name: 'db_destroy', label: 'Slettet'},
    {name: 'rollback', label: 'Tilbagerulning'},
  ],
  onboarding_type: [
    {key: 'template', id: 0, label: 'Skabelon'},
    {key: 'onboarding', id: 1, label: 'Onboarding'},
  ],
  onboarding_step_type: [
    {key: 'record_view', id: 0, label: 'Felter'},
    {key: 'document_upload', id: 1, label: 'Dokumenter'},
    {key: 'meeting_summary', id: 2, label: 'Mødereferat'},
    {key: 'approve', id: 3, label: 'Godkendelse'},
    {key: 'entity', id: 4, label: 'Mandat'},
    {key: 'client', id: 5, label: 'Kunde'},
    {key: 'risk_assessment', id: 6, label: 'Risikovurdering'},
    {key: 'allocation_limits', id: 7, label: 'Mandatgrænser'},
  ],
  onboarding_status: [
    {key: 'created', id: 0, label: 'Oprettet'},
    {key: 'active', id: 10, label: 'Aktiv'},
    {key: 'admin', id: 20, label: 'Admin'},
    {key: 'closed', id: 30, label: 'Lukket'},
    {key: 'cancelled', id: 40, label: 'Annulleret'}
  ],
  investment_type: [
    {key: 'none', id: 0, label: '', showWhere: 'all'},
    {key: 'free_funds', id: 1, label: 'Frie midler', showWhere: 'client'},
    {key: 'vso', id: 2, label: 'VSO', showWhere: 'client'},
    {key: 'pension', id: 3, label: 'Pension', showWhere: 'client'},
    {key: 'operation', id: 4, label: 'Driftselskab', showWhere: 'company'},
    {key: 'holding', id: 5, label: 'Holdingselskab', showWhere: 'company'},
    {key: 'fund', id: 6, label: 'Fond', showWhere: 'company'},
    {key: 'simulation', id: 7, label: 'Simulering', showWhere: 'simulation'},
    {key: 'total', id: 8, label: 'Total', showWhere: 'simulation'},
    {key: 'own_fund', id: 9, label: 'Egen fond', showWhere: 'simulation'},
    {key: 'external', id: 10, label: 'Ekstern', showWhere: 'simulation'},
  ],
  classification_type: [
    {key: 'privat', id: 0, label: 'Privat'},
    {key: 'institutional', id: 1, label: 'Institutionel'}
  ],
  client_type: [
    {key: 'retail', label: 'Detail', value: 1},
    {key: 'professionel', label: 'Professionel kunde', value: 2},
    {key: 'approved_opponent', label: 'Godkendt modpart', value: 3},
  ],
  client_reply: [
    {key: 'reject', label: 'Afvist', value: 0},
    {key: 'accept', label: 'Godkendt', value: 1},
    {key: 'pending', label: 'Afventer svar / Intet svar', value: 2}
  ],
  event_logs_validation_filters: [
    {name: 'with-errors', label: 'Med fejl'},
    {name: 'without-errors', label: 'Uden fejl'},
  ],
  event_logs_status_filters: [
    { name: 'created', label: 'Oprettet' },
    { name: 'processing', label: 'Behandles' },
    { name: 'imported', label: 'Importeret' },
    { name: 'rejected', label: 'Afvist' },
    { name: 'postponed', label: 'Udsat' },
    { name: 'system_error', label: 'Error' }
  ],
  event_type_filter: [
    { type: 'IncomeReceived', label: 'Modtaget indkomst', real: true },
    { type: 'CashEvent', label: 'Kontant begivenhed', real: true },
    { type: 'Trade', label: 'Handel', real: true },
    { type: 'TradeExpected', label: 'Forventet handel', real: false},
    { type: 'TradeCost', label: 'Handelsomkostning', real: true },
    { type: 'TradeCostExpected', label: 'Forventet handelsomkostning', real: true },
    { type: 'CashInterest', label: 'Kontorente', real: true },
    { type: 'DepositCost', label: 'Gebyr', real: true },
    { type: 'FeePayment', label: 'Honorarindbetaling', real: true },
    { type: 'FeeNeutralization', label: 'Honorar udligning', real: true },
    { type: 'Refund', label: 'Refusion', real: true }
  ],
  reconciliation_action_filter: [
    { id: 0, reconciliation_action: 'reconcile', label: 'Afstem' },
    { id: 1, reconciliation_action: 'skip_always', label: 'Spring over (altid)' },
    { id: 2, reconciliation_action: 'skip_temporary', label: 'Spring over (midlertidigt)' },
  ],
  reconciliation_type_filter: [
    { id: 0, reconciliation_type: 'bank', label: 'Bank' },
    { id: 1, reconciliation_type: 'sails', label: 'Sails' },
  ],
  loss_warning_event_type: [
    {name: 'LossWarning::ConsultantNotification', label: 'Rådgiver'},
    {name: 'LossWarning::ClientNotification', label: 'Kunde'},
    {name: 'LossWarning::EmployeeNotification', label: 'Medarbejder'}
  ],
    marking: [
      {key: 'Spectrum', id: 1, label: 'Spectrum'},
      {key: 'Trekantsområdet', id: 2, label: 'Trekantsområdet'},
      {key: 'Vendsyssel', id: 3, label: 'Vendsyssel'},
      {key: 'Midtvest', id: 4, label: 'Midtvest'},
      {key: 'Limfjorden', id: 5, label: 'Limfjorden'},
      {key: 'Aarhusbugten', id: 6, label: 'Aarhusbugten'}
    ],
  liquidAssetClasses: [
    'Aktier',
    'Obligationer',
    'Kontant'
  ],
  alternativeAssetClasses: [
    'Hedgefonde',
    'Finansiering',
    'Ejendomme',
    'Private Equity',
    'Infrastruktur',
    'Multi Strategi',
    'Direkte investeringer',
    'Buffer'
  ],

  // FYI: Defined in both store-enums.js and store-authenticated.js
  recordNameToController: [
    { recordName: 'Client', controller: 'Person'},
    { recordName: 'Administrator', controller: 'Person'},
    { recordName: 'Employee', controller: 'Person'},
    { recordName: 'BankContact', controller: 'Person'},
    { recordName: 'Trade', controller: 'Event'},
    { recordName: 'DepositCost', controller: 'Event'},
    { recordName: 'TradeExpected', controller: 'Event'},
    { recordName: 'TradeCost', controller: 'Event'},
    { recordName: 'TradeCostCancel', controller: 'Event'},
    { recordName: 'TradeCostExpected', controller: 'Event'},
    { recordName: 'TradeCancel', controller: 'Event'},
    { recordName: 'RefundCancel', controller: 'Event'},
    { recordName: 'Refund', controller: 'Event'},
    { recordName: 'RefundExpected', controller: 'Event'},
    { recordName: 'FeeCancel', controller: 'Event'},
    { recordName: 'FeeExpected', controller: 'Event'},
    { recordName: 'FeePayment', controller: 'Event'},
    { recordName: 'FeeNeutralization', controller: 'Event'},
    { recordName: 'IncomeCancel', controller: 'Event'},
    { recordName: 'IncomeReceived', controller: 'Event'},
    { recordName: 'IncomeTrade', controller: 'Event'},
    { recordName: 'Income', controller: 'Event'},
    { recordName: 'CashInterest', controller: 'Event'},
    { recordName: 'CashEvent', controller: 'Event'}
  ]
}

const getterObject = {
  portfolio_variance: (state) => (weights) => {
    let covmat = rootState.covmat
    let cov_index  = rootState.covmat_index
    if(cov_index.length == 0){
      return 0
    }
    if(weights.length == 0){
      return 0
    }

    // Find the intersection of weights and the index
    let sub_weights = weights.filter(w => cov_index.includes(w.issue_id)).sortBy('issue_id')
    if(sub_weights.length == 0){
      return 0
    }

    // Find positions in covmat to the weights, and create reduced covmat
    let cov_pos_to_weights = sub_weights.map(w => cov_index.findIndex(ci => ci == w.issue_id) )
    let sub_covmat = cov_pos_to_weights.map((row)=>{
      return cov_pos_to_weights.map((col)=>{
        return covmat[row][col]
      })
    })

    // Compute total value on and weights summing to 1
    let sum_value = 0
    sub_weights.forEach((w) => {sum_value += w.w})
    let scaled_weights = sub_weights.map(w => w.w/sum_value)

    // COMPUTE VARIANCE!
    var row, col, item, vector
    // CREATE A VECTOR FOR PRODUCT OF MATRIX AND WEIGHTS FOR THE FIRST TIME
    let variance = []
    for(row = 0; row < scaled_weights.length; row++){
      item = 0
      vector = sub_covmat[row]
      for(col = 0; col < scaled_weights.length; col++){
        item += vector[col]*scaled_weights[col]
      }
      variance.push(item)
    }
    // NOW TAKE THE PRODUCT OF THE VECTOR AND WEIGHTS
    item = 0
    for(row = 0; row < scaled_weights.length; row++){
      item += variance[row]*scaled_weights[row]
    }
    return item
  },
  selectableAssetClasses: (state) => {
    return state.assetClasses.filter(ac => ac.name != 'Buffer')
  }
}

const actionObject = {

}

export const state = rootState;
export const getters = getterObject;
export const actions = actionObject;
